module.exports = __webpack_public_path__ + "static/media/network_diagram.a96ce813.png";